import React, {useEffect, useState} from 'react';
import { observer } from 'mobx-react-lite';
import {Header, Loading} from '../../components';
import {Manager} from "../../core";
import { SettingsStore } from '../../stores/settings/settingsStore';
import {Colors} from "../../styles";
import { AiOutlineSave } from 'react-icons/ai';

const DEFAULT_SETTINGS = [
	{ name: 'BEDROOM', value: '20.0', label: 'Valor Quarto' },
	{ name: 'BATHROOM', value: '20.0', label: 'Valor Banheiro' },
	{ name: 'MIDDLE', value: '15.0', label: 'Valor Lavabo' },
	{ name: 'OFFICE', value: '20.0', label: 'Valor Escritório' },
	{ name: 'PATIO', value: '20.0', label: 'Valor Varanda' },
	{ name: 'STERILIZATION', value: '30.0', label: 'Esterilização-UV' },
	{ name: 'DEEP_CLEANING', value: '40.0', label: 'Limpeza Profunda Studio' },
	{ name: 'REGULAR_VALUE', value: '5.0', label: 'Adicional Limpeza Regular' },
	{ name: 'DEEP_VALUE', value: '5.0', label: 'Adicional Limpeza Profunda' },
	{ name: 'WEEKLY_LIGHT', value: '10%', label: 'Desconto Semanal Light' },
	{ name: 'BIWEEKLY_LIGHT', value: '10%', label: 'Desconto Quinzenal Light' },
	// { name: 'STUDIO_DISCOUNT', value: '10%', label: 'Desconto Studio' },
	{ name: 'WEEKLY_REGULAR', value: '10%', label: 'Desconto Semanal Regular' },
	{ name: 'BIWEEKLY_REGULAR', value: '10%', label: 'Desconto Quinzenal Regular' },
];

export const Settings = observer(() => {
	const { list, get, update } = SettingsStore();
	const [loading, setLoading] = useState(false);
	const [localSettings, setLocalSettings] = useState<any[]>(DEFAULT_SETTINGS);

	useEffect(() => {
		const fetchData = async () => {
			setLoading(true);
			try {
				const data = await get();
				// Merge defaults with server data
				const merged = DEFAULT_SETTINGS.map(def => {
					const serverItem = data.find((s: any) => s.name === def.name);
					return {
						...def,
						value: serverItem ? serverItem.value : def.value,
						id: serverItem ? serverItem.id : null
					};
				});
				setLocalSettings(merged);
			} catch (e) {
				console.error(e);
				alert('Erro ao carregar configurações.');
			} finally {
				setLoading(false);
			}
		};
		fetchData();
	}, [get]);

	const handleChange = (name: string, value: string) => {
		setLocalSettings(prev => prev.map(s => s.name === name ? { ...s, value } : s));
	};

	const handleSave = async () => {
		setLoading(true);
		try {
			await update(localSettings.map(s => ({ name: s.name, value: s.value })));
			alert('Configurações salvas com sucesso!');
		} catch (e) {
			console.error(e);
			alert('Erro ao salvar configurações.');
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className="m-2 md:m-10 mt-24 p-2 md:p-10 bg-white dark:bg-secondary-dark-bg dark:text-gray-200 rounded-3xl relative">
			{loading && (
				<div className="absolute inset-0 bg-white dark:bg-secondary-dark-bg bg-opacity-50 dark:bg-opacity-80 z-50 flex items-center justify-center">
					<Loading backgroundColor={Colors.light} type={'bubbles'} color={Colors.green_darker} />
				</div>
			)}
			<Header category="Administração" title="Configurações de Preços"/>
			
			<div className="mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
				{localSettings.map((setting) => (
					<div key={setting.name} className="bg-gray-50 dark:bg-[#33373E] p-4 rounded-xl border border-gray-200 dark:border-gray-700">
						<label className="block text-sm font-semibold text-gray-600 dark:text-gray-400 mb-2">
							{setting.label}
						</label>
						<input 
							type="text" 
							value={setting.value} 
							onChange={(e) => handleChange(setting.name, e.target.value)}
							className="w-full bg-white dark:bg-[#20232A] text-gray-800 dark:text-gray-100 border border-gray-300 dark:border-gray-600 p-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
						/>
						<span className="text-[10px] text-gray-400 mt-1 block uppercase">{setting.name}</span>
					</div>
				))}
			</div>

			<div className="mt-10 flex justify-end">
				<button 
					onClick={handleSave}
					disabled={loading}
					className="flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-8 rounded-xl shadow-lg transition-all transform hover:scale-105 active:scale-95"
				>
					{React.createElement(AiOutlineSave as any)}
					Salvar Alterações
				</button>
			</div>
		</div>
	);
});
